import React from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import { useLocation, useNavigate, useParams } from 'react-router-dom';
import OurLink from './OurLink';
import SingleViewPageTabs from './ViewPageTabs';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const SecondaryHeader = ({
  activeTab,
  setActiveTab,
  pageTitle,
  breadcrumbs,
  tabHeaders,
  otherDetails,
  backTo,
  showBackButton,
}) => {
  const location = useLocation();
  const navigate = useNavigate();
  const { projectId } = useParams();

  const mainPageUrl = `/project/${projectId}${
    location.pathname.includes('/testcycles') || location.pathname.includes('/testplayer')
      ? '/testcycles'
      : '/testcases'
  }`;

  const handleTabSelect = (tab) => {
    const currentUrl = new URL(window.location);
    currentUrl.searchParams.set('type', tab);
    navigate(`${location.pathname}${currentUrl.search}`, { state: location.state });
    setActiveTab(tab);
  };

  const handleBack = () => {
    navigate(backTo || mainPageUrl, { state: location.state });
  };

  return (
    <Container fluid>
      <Row
        className="align-items-center justify-content-between"
        style={{ padding: '0px 0px 0px 0px' }}>
        <Col className='px-0 d-flex justify-content-between'>
          <div>
            <div className="py-1">
              {breadcrumbs?.map((crumb, index) => (
                <React.Fragment key={index}>
                  <OurLink to={crumb.path} className={(index === breadcrumbs.length - 1 && !crumb.clickable) ? 'text-secondary' : ''} clickable={crumb.clickable}>{crumb.label}</OurLink>
                  {index < breadcrumbs.length - 1 && '> '}
                </React.Fragment>
              ))}
            </div>
            <h2 className="gainss-heading" style={{ overflowWrap: 'anywhere' }}>
              {pageTitle}
            </h2>
            {otherDetails && <div className="text-muted mb-2">{otherDetails}</div>}
          </div>
          {showBackButton && (
            <button
              onClick={handleBack}
              style={{
                background: 'none',
                border: 'none',
                cursor: 'pointer',
              }}
            >
              <KeyboardBackspaceIcon /> Back
            </button>
          )}
        </Col>
      </Row>
      <Row>
        <SingleViewPageTabs
          activeTab={activeTab}
          onTabSelect={handleTabSelect}
          tabHeaders={tabHeaders}
        />
      </Row>
    </Container>
  );
};

export default SecondaryHeader;
